import { api } from './client';

export type ChannelWideTableDateGrain = 'day' | 'week' | 'month' | 'quarter' | 'halfYear' | 'year';
export type ChannelWideTableReportTab = 'channel' | 'utm';

export interface ChannelWideTableRow {
  dimensions: Record<string, string>;
  metrics: Record<string, number>;
  raw_metrics: Record<string, number>;
}

export interface ChannelWideTableResponse {
  list: ChannelWideTableRow[];
  summary: ChannelWideTableRow | null;
  total: number;
  page: number;
  total_page: number;
  site_code: string;
  start_date: string;
  end_date: string;
  date_grain: string;
}

export interface ChannelWideTableMonitorParams {
  brand_id: string;
  site_id: string;
  start_date: string;
  end_date: string;
  date_grain: ChannelWideTableDateGrain;
  report_tab: ChannelWideTableReportTab;
  view_mode?: 'tree' | 'dimension';
  dimensions?: string;
  drill_dimensions?: string;
  page?: number;
  size?: number;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
  one_level_channel?: string;
  two_level_channel?: string;
  three_level_channel?: string;
  one_level_customer_group?: string;
  two_level_customer_group?: string;
  three_level_customer_group?: string;
  delivery_target?: string;
  delivery_target_detail?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}

export interface ChannelWideTableOptionParams {
  brand_id: string;
  site_id: string;
  report_tab: ChannelWideTableReportTab;
  field: string;
  search?: string;
  limit?: number;
}

export const channelWideTableApi = {
  getMonitor: (params: ChannelWideTableMonitorParams) =>
    api.get<{ code: number; data: ChannelWideTableResponse }>('/channel-wide-table/monitor', { params }),
  getOptions: (params: ChannelWideTableOptionParams) =>
    api.get<{ code: number; data: { list: string[] } }>('/channel-wide-table/options', { params }),
};
